import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTFUNNELRADIOITEMBLOCK_LEGACY_FIELD_ORDER = [
  "title",
  "required",
  "display_title_in_comment",
  "display_custom_title_in_comment",
  "custom_title"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartFunnelRadioItemBlockDescriptor: _generatedCartFunnelRadioItemBlockDescriptor,
  cartFunnelRadioItemBlockBlocDefinition,
  cartFunnelRadioItemBlockDashboardLayout,
  cartFunnelRadioItemBlockConfig,
  cartFunnelRadioItemBlockResolveConfig,
  cartFunnelRadioItemBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart funnel / Choices input",
    componentType: 'CartFunnelRadioItemBlockComponent',
    category: 'cart',
    description: "Cart funnel / Choices input.",
    keywords: [],
    allowedIn: [
      { bloc: "CartFunnelFormBlockComponent", slot: "items" },
    ],
    sharedFields: {}
,
    slots: [
      {
        key: 'options',
        name: "pages.blocks.cart-funnel-radio-item.options.label",
        accept: 'explicitOnly',
        allowedTypes: ["CartFunnelRadioOptionBlock"],
        slotItemFormat: 'ids',
      }
    ]
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-radio-item.title.label",
        help: "pages.blocks.cart-funnel-radio-item.title.help",
      }
    }),
    required: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.cart-funnel-radio-item.required.label",
      }
    }),
    display_title_in_comment: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.cart-funnel-radio-item.display-title-in-comment.label",
      }
    }),
    display_custom_title_in_comment: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.cart-funnel-radio-item.display-custom-title-in-comment.label",
      }
    }),
    custom_title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-radio-item.custom-title.label",
        help: "pages.blocks.cart-funnel-radio-item.custom-title.help",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-funnel-radio-item.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-funnel-radio-item.fieldset.field.label",
            fields: ["title", "required", "options"],
          },
          {
            legend: "pages.blocks.cart-funnel-radio-item.fieldset.order-comment.label",
            fields: [
              "display_title_in_comment",
              "display_custom_title_in_comment",
              {
                prop: "custom_title",
                visibleWhen: { display_custom_title_in_comment: true },
              },
            ],
          },
        ],
      },
    ],
  })
);

export function cartFunnelRadioItemBlockDescriptor(): IBlockDescriptor;
export function cartFunnelRadioItemBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartFunnelRadioItemBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartFunnelRadioItemBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartFunnelRadioItemBlockDescriptor, cartFunnelRadioItemBlockProperties, fieldOrder);
}

export {
  cartFunnelRadioItemBlockBlocDefinition,
  cartFunnelRadioItemBlockDashboardLayout,
  cartFunnelRadioItemBlockProperties,
  cartFunnelRadioItemBlockConfig,
  cartFunnelRadioItemBlockResolveConfig,
};

export type CartFunnelRadioItemBlockConfig = typeof cartFunnelRadioItemBlockConfig;
